import React from 'react';

import loadable from '@app/ui/components/LazyLoad';
import { useIsNonInteractiveViewer } from '@app/ui';
import { useIsNonFooterPage } from '@app/shell/SiteFooter/hooks';
import { useInView } from '@stockx/ui';

//
// Component to load
const Footer = loadable(
  () => import(/* webpackChunkName: "lazy.footer" */ './Footer'),
);

//
// Check to load
const useShouldShow = (): [any, boolean] => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const isNonFooterPage = useIsNonFooterPage();

  const [ref, inView] = useInView({
    rootMargin: '400px',
    triggerOnce: true,
  });

  return [ref, !isNonFooterPage && (isNonInteractiveViewer || inView)];
};

const FooterLazy = () => {
  const [ref, shouldShow] = useShouldShow();

  if (!shouldShow) {
    return <div ref={ref} style={{ width: '5px', height: '5px' }} />;
  }

  return <Footer />;
};

export default FooterLazy;
